export const DEBUG = false;
export var backendUrl = "";
export var frontendURL = "";
export var frontendURLWoProtocol = "";
export var siteName = "eleda.education";
export const server = process.env.VUE_APP_SERVER || "local";

export const MATOMO_ENABLED = false;

export const URLGarSortieConfiance =
  "https://sortie-confiance.gar.education.fr?idRessource=ark%3A%2F65668%2Feleda.pp&urlDest=";

export const commentoURL = "https://commento.eleda.community";
export const URLWebinarSubscription =
  "https://framaforms.org/inscription-webinaire-eleda-1670439815";
//Used in Login and App (for logout)
export const cookieCommentoName = "commentoCommenterToken";
export const URLTutorials = "https://www.youtube.com/@eleda-education";
export const URLForum = "https://forum.eleda.community";
export const URLForumSSO = "https://forum.eleda.community/session/sso";
export const URLForumFeatureRequests = URLForum + "/c/boite-a-idees";
export const URLForumBugReports = URLForum + "/c/besoin-daide/9";
export const URLForumReports = URLForum + "/c/signaler-un-contenu-inapproprié";
export const URLCompany = "https://kdetude.com";
export const emailSupport = "contact@eleda.fr";
export const emailContact = "contact@eleda.fr";

//DATABASE SETTINGS
console.log("Backend param server :" + server);
if (server == "production") {
  backendUrl = "https://backend.eleda.education";
  frontendURLWoProtocol = "eleda.education";
  frontendURL = "https://" + frontendURLWoProtocol;
  console.log = function () {};
} else if (server == "production-debug") {
  backendUrl = "https://backend.eleda.education";
  frontendURLWoProtocol = "debug.eleda.education";
  frontendURL = "https://" + frontendURLWoProtocol;
} else if (server == "dev") {
  backendUrl = "https://backend.eleda.dev";
  frontendURLWoProtocol = "dev.eleda.education";
  frontendURL = "https://" + frontendURLWoProtocol;
} else if (server == "devChris") {
  backendUrl = "http://192.168.10.100:8080";
  frontendURLWoProtocol = "192.168.10.100:3000";
  frontendURL = "http://" + frontendURLWoProtocol;
} else if (server == "devChrisWifi") {
  backendUrl = "http://192.168.10.101:8080";
  frontendURLWoProtocol = "192.168.10.101:3000";
  frontendURL = "http://" + frontendURLWoProtocol;
} else if (server == "devChrisPublic") {
  backendUrl = "http://45.80.20.168:8080";
  frontendURLWoProtocol = "45.80.20.168:3000";
  frontendURL = "http://" + frontendURLWoProtocol;
} else {
  backendUrl = "http://localhost:8080";
  frontendURLWoProtocol = "localhost:3000";
  frontendURL = "http://" + frontendURLWoProtocol;
}
//CHange this setting to switch on GANDI or localhost
//export const backendUrl = 'http://localhost:8080'
